<template>
    <div id="chart-panela" style="width: 100%; height:100%;"></div>
</template>

<script>
import toolTip from '../src/assets/imgs/bigAnchorImg.png';
export default {
    props: {
        // width: String,
        mapTackData: Array,
        provinceArr: Array
    },
    data(){
        return{}
    },
    created(){},
    watch: {
        mapTackData:{
            handler(){
                this.initMap();
            }
        }
    },
    methods: {
        initMap(){
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(document.getElementById('chart-panela'));
            // 指定图表的配置项和数据
            var option = {};
            //=============== start ===============//
            /**
             * 🚨🚨非常重要🚨🚨
             * 下面是 网站左侧代码，核心代码
             */
            var geoCoordMap = {
                '上海': [121.4648, 31.2891],
                '新疆': [86.9236, 41.5883],
                '甘肃': [103.9901, 36.3043],
                '江苏': [120.2062, 32.9208],
                '广西': [108.479, 24.1152],
                '江西': [116.0046, 28.6633],
                '安徽': [117.29, 32.0581],
                '内蒙古': [111.4124, 41.4901],
                '黑龙江': [127.9688, 46.868],
                '天津': [117.4219, 39.4189],
                '山西': [112.3352, 37.9413],
                '广东': [114.5107, 23.8196],
                '四川': [103.9526, 30.7617],
                '西藏': [91.1865, 30.1465],
                '云南': [101.9199, 25.0663],
                '浙江': [119.5313, 29.8773],
                '湖北': [113.0896, 31.3628],
                '辽宁': [123.1238, 42.1216],
                '山东': [117.1582, 36.8701],
                '河北': [115.4995, 38.6006],
                '福建': [118.0543, 26.5222],
                '青海': [97.4038, 35.8207],
                '陕西': [109.1162, 34.2004],
                '贵州': [106.6992, 26.7682],
                '河南': [113.4668, 34.6234],
                '重庆': [107.7539, 30.1904],
                '宁夏': [106.3586, 38.1775],
                '吉林': [125.8154, 44.2584],
                '湖南': [111.8823, 28.2568],
                '海南': [109.8500, 19.7028],
                '北京': [116.4551, 40.4539],
                '台湾': [121.0551, 23.9539],
            };
            //测试任务数量
            // var mapTackData = [
            // [
            //     {name: "北京", value: ''},{name: "上海", value: 10},
            //     {name: "新疆", value: ''}, {name: "西藏",value: Math.ceil(Math.random()*500)},
            //     {name: "宁夏", value: Math.ceil(Math.random()*500)}, {name: "甘肃",value: Math.ceil(Math.random()*500)},
            //     {name: "云南", value: Math.ceil(Math.random()*500)}, {name: "陕西",value: Math.ceil(Math.random()*500)},
            //     {name: "青海", value: Math.ceil(Math.random()*500)}, {name: "贵州",value: Math.ceil(Math.random()*500)},
            //     {name: "福建", value: Math.ceil(Math.random()*500)}, {name: "江西",value: Math.ceil(Math.random()*500)},
            //     {name: "四川", value: Math.ceil(Math.random()*500)}, {name: "江苏",value: Math.ceil(Math.random()*500)},
            //     {name: "安徽", value: Math.ceil(Math.random()*500)}, {name: "浙江",value: Math.ceil(Math.random()*500)},
            //     {name: "海南", value: Math.ceil(Math.random()*500)},
            //     {name: "天津", value: Math.ceil(Math.random()*500)}, {name: "重庆", value: Math.ceil(Math.random()*500)},
            //     {name: "广东", value: Math.ceil(Math.random()*500)}, {name: "广西", value: Math.ceil(Math.random()*500) },
            //     {name: "湖南", value: Math.ceil(Math.random()*500)}, {name: "湖北", value: Math.ceil(Math.random()*500)},
            //     {name: "河南", value: Math.ceil(Math.random()*500)}, {name: "河北", value: Math.ceil(Math.random()*500)},
            //     {name: "山东", value: Math.ceil(Math.random()*500)}, {name: "山西",value: Math.ceil(Math.random()*500)},
            //     {name: "黑龙江",value: Math.ceil(Math.random()*500)}, {name: "吉林", value: Math.ceil(Math.random()*500)},
            //     {name: "辽宁", value: Math.ceil(Math.random()*500)}, {name: "内蒙古", value: Math.ceil(Math.random()*500) },
            //     {name: "台湾", value: Math.ceil(Math.random()*500) }],
            // ]

            var mapShowArr = []
            var mapTackData = []
            var provinceArr = this.provinceArr
            var allData = this.mapTackData
            let that = this
            this.mapTackData.forEach(item => {
                if(item.name != '其他'){
                    let obj = {
                        name: item.name,
                        value: item.value
                    }
                    mapShowArr.push(obj)
                }
            });
            mapTackData = [mapShowArr]

            var pro = ['江苏','黑龙江','内蒙古','吉林','北京','辽宁','河北','天津','山西','陕西','甘肃','宁夏','青海','新疆','四川','重庆','山东','河南','安徽','湖北','浙江','福建','江西','湖南','贵州','云南','广东','广西','海南','上海','西藏','台湾','南海诸岛','香港','澳门']
            var year = ['2021-06-17'];
            //柱状体宽度
            let barWidth = 4;
            //测试详细信息
            var mapDetailed = {}
            //模拟数据赋值
            for(var i = 0; i < pro.length; i++){
                var arr = {};
                var map = {};
                map['需要测试数量'] = Math.ceil(Math.random()*500);
                map['测试通过数量'] = Math.ceil(Math.random()*500);
                map['测试不通过数量'] = Math.ceil(Math.random()*500);
                map['不具备测试条件'] = Math.ceil(Math.random()*500);
                map['未测试数量'] = Math.ceil(Math.random()*500);
                var proName = pro[i]
                mapDetailed.name = proName
                mapDetailed[proName] = map
            }

            //地图模拟测试计划数据
            var mapData = [];
            /*柱子颜色区分*/
            var barColorsData = [];
            //数据模拟提前加数组
            for(var i = 0;i < year.length; i++){
                var j = [];
                mapData.push(j)
            }

            //生成从minNum到maxNum的随机数 地图用
            function randomNum(minNum, maxNum) {
                switch (arguments.length) {
                    case 1:
                        return parseInt(Math.random() * minNum + 1, 10);
                    break;
                    case 2:
                        return parseInt(Math.random() * ( maxNum - minNum + 1 ) + minNum, 10);
                    //或者 Math.floor(Math.random()*( maxNum - minNum + 1 ) + minNum );
                    break;
                    default:
                        return 0;
                    break;
                }
            }
            for (var i = 0;i < year.length; i++) {
                var barColors = {}
                for(var j = 0;j < pro.length; j++){
                    var proValue = randomNum(1, 3);
                    var proName = pro[j]
                    mapData[i].push({
                        "name": proName,
                        "value": proValue,
                    });
                    barColors[proName] = proValue;
                }
                barColorsData.push(barColors);
            }
            var convertData = function(data) {
                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var geoCoord = geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value)
                        });
                    }
                }
                return res;
            };
            option = {
                // const provinceArr = this.provinceArr
                // const this.provinceArr.includes(name)
                timeline: {
                    show: false,
                },
                baseOption: {
                    animation: true,
                    animationDuration: 1000,
                    animationEasing: 'cubicInOut',
                    animationDurationUpdate: 1000,
                    animationEasingUpdate: 'cubicInOut',
                    grid: {
                        right: '5%',
                        top: '0%',
                        bottom: '10%',
                        width: '18%'
                    },
                    tooltip: {
                        trigger: 'item',
                      padding: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                      borderColor: 'rgba(0, 0, 0, 0)',
                        formatter: function(a){
                            let name = a.data.name
                            let obj = {}
                            allData.forEach(item => {
                                if(item.name == name){
                                    obj = item
                                }
                            });
                            if(provinceArr.includes(name)){
                                // let result = `<div style="padding: 20px; background-image: url(${toolTip}); width:150px; height: 119px; background-size: 100% 100%; line-height: 30px; color: #FFFFFF">`;
                                //     result += `</br>${obj.value} 人`;
                                //     result += `${obj.name}`;
                                
                                let result = `<div class="movile_hover" ><img src='${require('../src/assets/imgs/bigAnchorImg.png')}' style='display: block; position: absolute;'></img>
                                <p class="nameClass" style='position: absolute; top: 13px; left: 4px; width: 128px; text-align: center; word-break: keep-all; color: #FFFFFF; font-size: 12px'>${obj.name}</P>
                                <p class="nameClass" style='position: absolute; top: 50px; left: 10px; width: 128px; text-align: center; font-weight: 600; word-break: keep-all; color: #00E8FF; font-size: 20px'>${obj.value} <span style="color: #fff; font-size: 14px">人</span> </P>`
                                return result;

                            }else{
                                return ('')
                            }

                            // return ('共 ' + mapDetailed[a['name']]['需要测试数量'] + ' 人'
                            //     +'</br>销售: ' + mapDetailed[a['name']]['测试通过数量'] + ' 人'
                            //     +'<br>考生: ' + mapDetailed[a['name']]['测试不通过数量'] + ' 人'
                            //     +'<br>新媒体: ' + mapDetailed[a['name']]['不具备测试条件'] + ' 人')
                        }
                    },
                    visualMap: {
                        show: false,
                        // type: 'piecewise',
                        showLabel: 'true',
                        seriesIndex: [1],
                        left: '5%',
                        bottom: '1%',
                        text: ['生产测试计划'],
                        pieces: [
                            {
                                min:3,
                                max:3,
                                label: '生产测试省分&冒烟测省分',
                                color: '#367a9d'
                            },
                            {
                                min:1,
                                max:1,
                                label: '生产冒烟省分',
                                color: '#367a9d',
                            },
                            {
                                min:2,
                                max:2,
                                label: '生产测试省分',
                                color: '#367a9d',
                            }
                        ],
                        textStyle: {
                            color: '#000000',
                        },
                    },
                    geo: {
                        map: 'china',
                        center: [113.83531246, 34.0267395887],
						layoutSize: '105%',
						    // 确保地图在容器中居中显示
						layoutCenter: ['66.5%', '45%'],
                        label: {
                            emphasis: {
                                show: false,//鼠标上去不显示省份名字
                            }
                        },
                        itemStyle: {
                            // 鼠标放上去后的颜色
                            emphasis: {
                                areaColor: '#367a9d'
                            },
                            // itemStyle: {
                            //     color: '#fff',
                            //     areaColor: "rgba(255, 88, 78, .5)",
                            //     // borderColor: '#000',
                            //     // borderWidth: 20
                            // },
                        },
                        //重点下面，与点击事件不同，虽然也是点击选中，但是事件不一样
                        selectedMode:"single", //选择模式，单选，只能选中一个地市
                        select:{//这个就是鼠标点击后，地图想要展示的配置
                            disabled:false,//可以被选中
                            itemStyle:{//相关配置项很多，可以参考echarts官网
                                areaColor:"#367a9d", //选中后颜色、点击颜色
                            },
                            label: {
                                show: false
                            }
                        },
                    },
                },
                options: []
            };
            for (var n = 0; n < year.length; n++) {
                option.options.push({
                    series: [
                        //未知作用
                        {
                            show: false,
                            //文字和标志
                            name: 'light',
                            type: 'scatter',
                            coordinateSystem: 'geo',
                            data: convertData(mapTackData[n]),
                            symbolSize: function(val) {
                                return 6;
                            },
                            label: {
                                normal: {
                                    show: true,
                                    // position: "bottom", //显示位置
                                    // offset: [0, 0], //偏移设置
                                    color: "white",
                                    formatter: "{b}", //圆环显示文字
                                    fontWeight: "bold",
                                    fontSize: 11
                                }
                            },
                            itemStyle: {
                                // 小圆点颜色
                                color :'transparent',
                            }
                        },
                        //地图
                        {
                            type: 'map',
                            map: 'china',
                            geoIndex: 0,
                            data: mapData[n]
                        },
                        //生产冒烟省分
                        {
                            // name: '生产冒烟省份',
                            type: 'scatter',
                            //   type: 'effectScatter',
                            coordinateSystem: 'geo',
                            data: convertData(mapTackData[n]),
                            symbol: 'pin',

                            // symbol: 'image://http://kiwispacecs.yinjuejy.com/img/backimg.png',
                            show: true,
                            // label: {

                            //     formatter: [
                            //         '{a|这段文本采用样式a}',
                            //         '{b|这段文本采用样式b}这段用默认样式{x|这段用样式x}'
                            //     ].join('\n'),

                            //     rich: {
                            //         a: {
                            //             color: 'red',
                            //             lineHeight: 10
                            //          },
                            //         b: {
                            //             backgroundColor: {
                            //                 image: 'xxx/xxx.jpg'
                            //             },
                            //             height: 40
                            //         },
                            //         x: {
                            //             fontSize: 18,
                            //             fontFamily: 'Microsoft YaHei',
                            //             borderColor: '#449933',
                            //             borderRadius: 4
                            //         }
                            //     },
                            // },
                            // symbol: {
                            // },
                            // color: '#f2d643', //颜色
                            color: '#193B7B', //气泡颜色
                            // symbolSize: function(val) {
                            //     return val[1];
                            // },
                            // symbolOffset: [1,10],
                            symbolSize: 40,
                            // symbolOffset: [0, 4],
                            label: {
                                show: true,
                                fontStyle: 'normal' ,
                                position: 'inside',
                                color:'white',
                                formatter: function(params) {
                                    return params.value[2];
                                },
                            }
                        },
                    ]
                });
            }

            //=============== end ===============//
            // 使用刚指定的配置项和数据显示图表。
            if (option && typeof option === 'object') {
                myChart.setOption(option);
            }
            // 点击事件
            myChart.on('click', function (params) {
                if (params.componentType === 'series') {
                    var name = params.name; // 点击的省份名称
                    // 处理点击事件，例如弹窗显示信息
                    console.log(name)
                    if(provinceArr.includes(name)){
                        that.$emit('choiceProvince', name)
                    }else{
                        // alert('暂无数据');
                        // that.$message({
                        //     message: '暂无数据',
                        //     type: 'warning'
                        // });
                    }
                }
            });
            window.addEventListener('resize', myChart.resize);
        }
    }
}
</script>

<style >
	@media (max-width: 768px) {
	  #chart-panela{
		  width: 100%;
		  height: 100%;
	  }
	  .movile_hover {
	    display: none;
	  }
	}
</style>
